import type { OnDestroy } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import type { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import type { Observable } from 'rxjs';
import { map, Subject, take, takeUntil } from 'rxjs';

import type { ConfigConfirmDialog } from './config';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable()
export class ConfirmDialogService implements OnDestroy {
  readonly #dialog = inject(MatDialog);
  private readonly destroyed$: Subject<void>;
  constructor() {
    this.destroyed$ = new Subject();
  }

  dialogRef!: MatDialogRef<ConfirmDialogComponent>;

  open(options: ConfigConfirmDialog, func?: (res: boolean) => void): void {
    this.dialogRef = this.#dialog.open(ConfirmDialogComponent, {
      panelClass: 'confirm-dialog',
      width: options.width,
      data: options,
    });
    this.dialogRef
      .afterClosed()
      .pipe(
        take(1),
        takeUntil(this.destroyed$),
        map((res: boolean | undefined) => {
          return res !== undefined ? res : false;
        }),
      )
      .subscribe((value) => func && func(value));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  confirmed(): Observable<boolean> {
    return this.dialogRef.afterClosed().pipe(
      take(1),
      takeUntil(this.destroyed$),
      map((res: boolean | undefined) => {
        return res !== undefined ? res : false;
      }),
    );
  }
}
